import type { ReactNode } from "react";
import Link, { type LinkProps } from "next/link";
import styles from "./Button.module.css";

type ButtonVariant = "primary" | "secondary" | "outline" | "ghost";
type ButtonSize = "sm" | "md" | "lg";

type LinkHref = LinkProps<never>["href"];

interface LinkButtonProps {
  href: LinkHref;
  variant?: ButtonVariant;
  size?: ButtonSize;
  className?: string;
  children: ReactNode;
  "aria-label"?: string;
}

export default function LinkButton({
  href,
  variant = "primary",
  size = "md",
  className = "",
  children,
  "aria-label": ariaLabel,
}: LinkButtonProps) {
  const buttonClasses = `${styles.btn} ${styles[`btn-${variant}`]} ${styles[`btn-${size}`]} ${className}`;

  return (
    <Link href={href} aria-label={ariaLabel} className={buttonClasses}>
      {children}
    </Link>
  );
}

